import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2, Rocket, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, auth, errMsg } from "../../lib/api";
import { PublicNav } from "../../components/PublicNav";
import { Seo } from "../../components/Seo";

export default function ResumeDemo() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    api.post("/public/scan/resume", { code })
      .then(({ data }) => {
        auth.login(data.token, data.user);
        toast.success(`Welcome back, ${data.user.name.split(" ")[0]} — your ${data.entity.race_label} workspace is open again`);
        navigate("/dashboard", { replace: true });
      })
      .catch((e) => setError(errMsg(e, "That demo link isn't valid anymore.")));
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-app text-white" data-testid="resume-demo-page">
      <Seo title="Reopening your demo" noindex path={`/scan/r/${code}`} />
      <PublicNav compact />
      <main className="max-w-md mx-auto px-5 py-24 text-center space-y-4">
        {!error ? (
          <div className="text-sm text-slate-300 flex flex-col items-center gap-3" data-testid="resume-loading">
            <Loader2 className="w-8 h-8 animate-spin text-amber-300" /> Reopening your demo workspace…
          </div>
        ) : (
          <div className="rounded-2xl border border-rose-400/30 bg-rose-400/10 p-5 space-y-3" data-testid="resume-error">
            <AlertTriangle className="w-6 h-6 text-rose-300 mx-auto" />
            <div className="text-sm text-rose-100">{error}</div>
            <button onClick={() => navigate("/scan")} data-testid="resume-find-race-btn"
              className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-amber-400 to-amber-600 text-on-accent font-bold px-5 py-2.5 text-sm">
              <Rocket className="w-4 h-4" /> Find my race again
            </button>
          </div>
        )}
      </main>
    </div>
  );
}
